/* SawaKart Brands page (sections/sk-brands.liquid): search filters the brand cards as you type (the
   count, empty message, letter groups and A–Z bar follow), letters without brands are dimmed, and
   the letter of the group in view is highlighted. The A–Z bar sticks right under the sticky site
   header, whose height depends on the breakpoint: --skb-top / --skb-bar-h are measured here. */
(function () {
  'use strict';
  var root = document.querySelector('[data-sk-brands]');
  if (!root) return;

  var input = root.querySelector('[data-skb-search]');
  var clear = root.querySelector('[data-skb-clear]');
  var count = root.querySelector('[data-skb-count]');
  var empty = root.querySelector('[data-skb-empty]');
  var popular = root.querySelector('[data-skb-popular]');
  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-skb-group]'));
  var letters = Array.prototype.slice.call(root.querySelectorAll('[data-skb-letter]'));
  var total = root.querySelectorAll('[data-skb-groups] .skb-card').length;
  var bar = root.querySelector('[data-skb-letters]');
  var header = document.querySelector('header.site-header[data-site-header]');

  function place() {
    if (header) {
      var cs = getComputedStyle(header);
      if (cs.position === 'sticky' || cs.position === 'fixed') {
        root.style.setProperty('--skb-top', Math.round((parseFloat(cs.top) || 0) + header.offsetHeight) + 'px');
      }
    }
    root.style.setProperty('--skb-bar-h', bar.offsetHeight + 'px');
  }
  place();
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(place);
    if (header) ro.observe(header);
    ro.observe(bar);
  } else {
    window.addEventListener('resize', place);
  }

  function plural(n) { return n + (n === 1 ? ' brand' : ' brands'); }

  function apply() {
    var q = input.value.trim().toLowerCase();
    var shown = 0;
    var present = {};
    groups.forEach(function (g) {
      var inGroup = 0;
      g.querySelectorAll('.skb-card').forEach(function (c) {
        var hit = !q || c.getAttribute('data-skb-name').indexOf(q) !== -1;
        c.hidden = !hit;
        if (hit) inGroup += 1;
      });
      g.hidden = inGroup === 0;
      if (inGroup) present[g.getAttribute('data-skb-group')] = true;
      shown += inGroup;
    });
    letters.forEach(function (a) {
      var on = !!present[a.getAttribute('data-skb-letter')];
      a.classList.toggle('is-off', !on);
      if (on) a.removeAttribute('aria-disabled'); else a.setAttribute('aria-disabled', 'true');
      a.tabIndex = on ? 0 : -1;
    });
    if (popular) popular.hidden = !!q;
    empty.hidden = shown > 0;
    clear.hidden = !q;
    count.textContent = q ? plural(shown) + ' found' : plural(total);
  }

  var timer = 0;
  input.addEventListener('input', function () {
    clearTimeout(timer);
    timer = setTimeout(apply, 120);
  });
  clear.addEventListener('click', function () {
    input.value = '';
    apply();
    input.focus();
  });
  apply();

  // Highlight the letter of the group at the top of the screen.
  if ('IntersectionObserver' in window) {
    var byLetter = {};
    letters.forEach(function (a) { byLetter[a.getAttribute('data-skb-letter')] = a; });
    var below = Math.round(bar.getBoundingClientRect().height + (parseFloat(getComputedStyle(root).getPropertyValue('--skb-top')) || 100) + 8);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        letters.forEach(function (a) { a.classList.remove('is-current'); });
        var a = byLetter[e.target.getAttribute('data-skb-group')];
        if (!a) return;
        a.classList.add('is-current');
        // the bar scrolls sideways below desktop: keep the current letter in view
        if (bar.scrollWidth > bar.clientWidth) {
          bar.scrollTo({ left: a.offsetLeft - (bar.clientWidth - a.offsetWidth) / 2, behavior: 'smooth' });
        }
      });
    }, { rootMargin: '-' + below + 'px 0px -60% 0px' });
    groups.forEach(function (g) { io.observe(g); });
  }
})();
